export const tableschema5 = {
    "name_table": "Розділ V. Розподіл дітей у групах за мовами виховання",
    "titles": [
        "Усі мови виховання у тому числі",
        "українська",
        "англійська",
        "болгарська",
        "гагаузька",
        "їдиш або іврит",
        "кримськотатарська",
        "німецька",
        "польська",
        "румунська",
        "словацька",
        "угорська",
        "чеська",
        "інші"
    ],
    "parts": [
        {
            "title": "Кількість",
            "subtitle": "груп",
            "fields": [
                "LNG11",
                "LNG12",
                "LNG13",
                "LNG14",
                "LNG15",
                "LNG16",
                "LNG17",
                "LNG18",
                "LNG19",
                "LNG110",
                "LNG111",
                "LNG112",
                "LNG113",
                "LNG114"
            ]
        },
        {
            "title": "Кількість",
            "subtitle": "дітей",
            "fields": [
                "LNG4000",
                "LNG4010",
                "LNG4030",
                "LNG4040",
                "LNG25",
                "LNG26",
                "LNG4050",
                "LNG4070",
                "LNG4080",
                "LNG4090",
                "LNG4100",
                "LNG4110",
                "LNG213",
                "LNG214"
            ]
        }
    ],
    "shorts": {
        "titles": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14"
        ],
        "parts": [
            "1",
            "2"
        ]
    }
};